import { InfoItemProps } from "@/components/organisms";
import { defaultDateFormat } from "@/core/date";
import { defaultCurrencyFormat, defaultDecimalFormat, defaultPercentFormat } from "@/core/number";
import i18n from "@/i18n";

export const panelDescriptionSchema = (details: MyBrokerApi.Trailer, language: string): InfoItemProps[] => [
    {
        key: "brand",
        label: i18n.t("InsuredGood.Details.Trailer.Brand"),
        value: details.description?.brand,
    },
    {
        key: "trailerType",
        label: i18n.t("InsuredGood.Details.Trailer.TrailerType"),
        value: details.description?.trailerSemiTrailer.name,
    },
    {
        key: "genre",
        label: i18n.t("InsuredGood.Details.Trailer.Nature"),
        value: details.description?.genre.name,
    },
    {
        key: "chassis",
        label: i18n.t("InsuredGood.Details.Trailer.Chassis"),
        value: details.description?.chassis,
    },
    {
        key: "maxMass",
        label: i18n.t("InsuredGood.Details.Trailer.MaxMass"),
        value: defaultDecimalFormat(+details.description?.maxMassAllowedKg, language, "kg"),
    },
    {
        key: "emptyMass",
        label: i18n.t("InsuredGood.Details.Trailer.EmptyMass"),
        value: defaultDecimalFormat(+details.description?.emptyMassKg, language, "kg"),
    },
    {
        key: "payload",
        label: i18n.t("InsuredGood.Details.Trailer.Payload"),
        value: defaultDecimalFormat(+details.description?.payloadKg, language, "kg"),
    },
    {
        key: "valueWithoutVAT",
        label: i18n.t("InsuredGood.Details.Trailer.ValueWithoutVAT"),
        value: defaultCurrencyFormat(+details.description.valueWithoutVAT, language),
    },
    {
        key: "valueVATExemption",
        label: i18n.t("InsuredGood.Details.Trailer.VATExemption"),
        value: defaultPercentFormat(+details.description?.taxExemption, language),
    },
];

export const panelKeyDatesSchema = (details: MyBrokerApi.Trailer): InfoItemProps[] => [
    {
        key: "constructionYear",
        label: i18n.t("InsuredGood.Details.Trailer.ConstructionYear"),
        value: details.registrationDates?.constructionYear,
        hideIfZero: true,
    },
    {
        key: "registrationDate",
        label: i18n.t("InsuredGood.Details.Trailer.RegistrationDate"),
        value: defaultDateFormat(details.registrationDates?.registrationDate),
    },
    {
        key: "firstUseDate",
        label: i18n.t("InsuredGood.Details.Trailer.FirstUseDate"),
        value: defaultDateFormat(details.registrationDates?.firstUseDate),
    },
];
